var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    width: "10px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134 149.8",
    style: {
      enableBackground: "new 0 0 134 149.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:\"#00000\";}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11,108.7l-0.6-0.6c-2.5-2.5-2.5-6.7,0-9.2l39.8-39.8c2.5-2.5,6.7-2.5,9.2,0l21.5,21.5l41.7-46.9 c2.5-2.8,6.9-2.9,9.5-0.3c2.4,2.5,2.5,6.4,0.3,8.9L85.5,95c-2.5,2.8-6.8,2.9-9.5,0.3L54.8,74.1l-34.6,34.6 C17.7,111.2,13.6,111.2,11,108.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.2,147.9l34.6-34.6l21.2,21.2c2.7,2.7,7,2.5,9.5-0.3l46.8-52.7c2.3-2.5,2.2-6.5-0.3-8.9 c-2.6-2.6-7-2.5-9.5,0.3l-41.7,46.9L59.4,98.2c-2.5-2.5-6.7-2.5-9.2,0l-39.8,39.8c-2.5,2.5-2.5,6.7,0,9.2l0.6,0.6 C13.6,150.4,17.7,150.4,20.2,147.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.5,26.1H26.1v16.3c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3V26.1H3.3c-1.8,0-3.3-1.5-3.3-3.3 c0-1.8,1.5-3.3,3.3-3.3h16.3V3.3c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3v16.3h16.3c1.8,0,3.3,1.5,3.3,3.3 C45.7,24.7,44.3,26.1,42.5,26.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.3089e24d0f47401a57f19defdb840a4a.svg";
export { ForwardRef as ReactComponent };